import React from "react";
import PropTypes from "prop-types";
import StyledButton from "../StyledButton/StyledButton";
import styled, { withTheme } from "styled-components";

const StyledLightBtn = styled(StyledButton)`
  color: ${(props) => props?.theme?.mortar};
  background-color: ${(props) => props?.theme?.whiteSmoke};
  border-color: ${(props) => props?.theme?.whiteSmoke};
  font-weight: 600 !important;

  &:hover,
  &:focus {
    color: ${(props) => props?.theme?.mortar} !important;
    background-color: ${(props) => props?.theme?.whiteSmoke} !important;
    border-color: ${(props) => props?.theme?.whiteSmoke} !important;
  }
  &:focus {
    box-shadow: 0px 3px 6px #0000001a !important;
  }
`;

const LightButton = (props) => {
  const { text, size } = props;

  return (
    <StyledLightBtn {...props} size={size}>
      {text || props.children}
    </StyledLightBtn>
  );
};

LightButton.propTypes = {
  size: PropTypes.oneOf(["lg", "", "sm"]),
};

export default withTheme(LightButton);
